export const showCongratulations = (id) => {
  if (id && typeof id === "string") {
    let mantraId = [];
    try {
      mantraId = localStorage.getItem("completed");
      mantraId = JSON.parse(mantraId);
    } catch (error) {}

    if (mantraId && mantraId.length > 0) {
      // console.log("if");
      let newArr = mantraId;
      newArr.push(id);
      newArr = [...new Set(newArr)]
      localStorage.setItem("completed", JSON.stringify(newArr));
    } else {
      // console.log("else");
      let arr = [];
      arr.push(id);
      localStorage.setItem("completed", JSON.stringify(arr));
    }
  } else {
    return "Please pass an integer value."
  }
};
